// extracted by mini-css-extract-plugin
module.exports = {"SignalText":"Signals_SignalText__2qpbY","warning":"Signals_warning__h6Uf_"};